import { FormProvider, useForm } from "react-hook-form";
import { useSetZIndex } from "../../../../../../../../../hooks/useSetZIndex";
import { CustomModal } from "../../../../../../../../../components/ui/CustomModal/CustomModal";
import { ipPattern } from "../../../../../../../../../utils/constants/IpPattern";
import { ModalInput } from "../../../../../../../../../components/ui/ModalInput/ModalInput";
import { Button } from "../../../../../../../../../components/ui/Buttons/Button/Button";
import "./RemoveIpModal.scss";
import { useTranslation } from "../../../../../../../../../hooks";

export const AddIpModal = ({ onClose }) => {
  useSetZIndex(".cabinet", "999");

  const methods = useForm({
    mode: "onChange"
  });

  const { cabinet: { orders: { residential: { addButton, cancel } } } } = useTranslation();

  const onSubmit = () => {
    // console.log(data);
  };

  return (
    <CustomModal
      open={true}
      onClose={onClose}
      styles={{ zIndex: "999999999" }}
    >
      <div className="remove-ip-modal">
        <div className="remove-ip-modal__title">{addButton}</div>
        <div className="remove-ip-modal__ip-input">
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <ModalInput
                name="authIp"
                rules={{
                  required: true,
                  pattern: ipPattern
                }}
                mask
                label="IP"
                defaultValue=""
                ipMask
                // handler={() => {}}
              />
            </form>
          </FormProvider>
        </div>
        <div className="remove-ip-modal__actions">
          <Button>{cancel}</Button>
          <Button tab="confirm">{addButton}</Button>
        </div>
      </div>
    </CustomModal>
  );
};
